export default __webpack_public_path__ + "static/nl-959228c6f939a5cb63e44dc2eea672c6.svg";